import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {isPublicUser} from '../utils/isPublicUser';

export const canLogout = () => {
	return !isBrandPortal() || !isPublicUser();
};
